import zh from 'element-ui/lib/locale/lang/zh-CN';

export default {
  ...zh,
  hanshow: '汉朔',
  'no data': '暂无数据',
  'confirm': '确定',
  'cancel': '取消',
  'select all': '全选',
  hs: {
    'button': {
      'search': '查询',
      'reset': '重置',
      'close': '收起',
      'open': '展开',
    },
    'prev': '上一步',
    'next': '下一步',
    'jump': '跳过',
    'finish': '结束',
  }
}